import { createWebHistory, createRouter } from "vue-router";
import Home from "./components/Home.vue";
import Login from "./components/Login.vue";
import Register from "./components/Register.vue";
// lazy-loaded
const ListCupom = () => import("./components/ListCupom.vue")
const ListUsedCupom = () => import("./components/ListUsedCupom.vue")
const CreateCupom = () => import("./components/CreateCupom.vue")
const EditCupom = () => import("./components/EditCupom.vue")

const routes = [
  {
    path: "/",
    name: "home",
    component: ListCupom,
  },
  {
    path: "/home",
    component: Home,
  },
  {
    path: "/login",
    component: Login,
  },
  {
    path: "/register",
    component: Register,
  },
  {
    path: "/cupom/utilizados",
    name: "listUsedCupons",
    component: ListUsedCupom,
  },
  {
    path: "/cupom/novo",
    name: "createCupom",
    component: CreateCupom,
  },
  {
    path: "/cupom/:id",
    name: "editCupom",
    component: EditCupom,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;